import ChangesList from './ChangesList';

export default {
    list: ChangesList,
}

